import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import styles from './level.module.scss';
import Element from '../../element';
interface IProps extends HTMLProps<HTMLDivElement> {
    className?: string;
    narrow?: boolean;
    children: React.ReactNode;
}

function LevelItem(props: IProps) {
    const { className, children, narrow, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(styles['level-item'], className, {
                [styles['is-narrow']]: narrow,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(LevelItem);
